<ng-container *ngIf="userService.loggedIn(); else navUnauthenticated">

    <nav class="bg-light navbar navbar-expand-xl navbar-light navbar-primary navbar-primary-home-2">
        <div class="container-fluid">
            <a class="navbar-brand" [routerLink]="'/'" title="Ir a Home de Profejobs"><img src="images/logo.png"
                    alt="Logotipo de Profejobs" class="logo-main-navbar" /></a>

            <div class="align-items-center d-flex fix-switch">


                <!--
            
                <ul *ngIf="userService.isEmployee()"
                    class="navbar-nav navbar-nav-user-info navbar-nav-no-hover navbar-nav-custom align-items-center">
                    <li class="d-xl-none">
                        <navigation-bar-employee-substitution [idLink]="'linkSubstituteDesk'"
                            (eventOpenModal)="onEventOpenModalSubstitute($event)"
                            (eventSaveRecord)="onEventSaveSubstitute($event)"
                            #navigationBarEmployeeSubstitutionMobile></navigation-bar-employee-substitution>
                    </li>

                </ul>
                -->

                <button id="btn-navbar-toggler" class="navbar-toggler" type="button" data-toggle="collapse"
                    data-target="#navbarToggler2" aria-controls="" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
            </div>
            <div class="collapse justify-content-sm-end navbar-collapse navbar-collapse-padding-sm" id="navbarToggler2">
                <div class="mr-lg-auto wrap-navItem">
                    <app-navigation-bar-white [class]="'nav nav-style-1 no-overflow-x'">
                    </app-navigation-bar-white>
                </div>




                <div class="align-items-center d-flex fix-switch">
                    <ul
                        class="navbar-nav navbar-nav-user-info navbar-nav-no-hover navbar-nav-custom align-items-center">

                        <!-- 

                        <li class="d-none d-xl-inline-block">
                            <navigation-bar-employee-substitution [idLink]="'linkSubstituteMobile'"
                                (eventOpenModal)="onEventOpenModalSubstitute($event)"
                                (eventSaveRecord)="onEventSaveSubstitute($event)" *ngIf="userService.isEmployee()"
                                #navigationBarEmployeeSubstitutionDesktop></navigation-bar-employee-substitution>

                        </li>

                        -->

                        <app-navigation-bar-employee-config #navigationBarEmployeeConfig>
                        </app-navigation-bar-employee-config>



                        <div class="wrap-img" *ngIf="userService.getUserPhoto()">
                            <img loading="lazy" class="school-img" alt="Logotipo del colegio"
                                src="{{userService.getUserPhoto()}}" />
                        </div>

                        <li class="nav-item dropdown dropdown-personal-setting">
                            <a class="dropdown-toggle nav-link pj-ico" href="#" id="dropdownMainMenu"
                                data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">{{userService.getUserName()}}</a>
                            <div [class.dropdown-menu-right]="innerWidth1200" class="dropdown-menu dropdown-menu-left"
                                aria-labelledby="dropdownMainMenu">
                                <a role="button" class="dropdown-item">Perfil:
                                    <b>{{userService.getUserProfile()}}</b></a>
                                <a *ngIf="userService.isAdminEmployer()" class="dropdown-item" role="button"
                                    [routerLink]="['/', path_module_admin.module, path_module_admin.changeemployer]">Seleccionar
                                    institución</a>
                                <a class="dropdown-item" *ngIf="userService.isEmployer()" role="button"
                                    (click)="onClickEditUser($event)">Editar
                                    usuario</a>
                                <a *ngIf="userService.isEmployee()" class="dropdown-item"
                                    [routerLink]="'/' + [constantsService.BASE_PATH_EMPLOYEE_EDIT] ">Editar perfil</a>
                                <a *ngIf="userService.isEmployer()" role="button" class="dropdown-item"
                                    [routerLink]="['/', path_module_employer.module, path_module_employer.changepass]">Cambiar
                                    contraseña</a>
                                <a *ngIf="!userService.isEmployer()" role="button" class="dropdown-item"
                                    [routerLink]="[constantsService.BASE_PATH_CHANGEPASS]">Cambiar contraseña</a>
                                <a role="button" class="dropdown-item"
                                    [routerLink]="['/', path_module_public.logout]">Cerrar
                                    sesión</a>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>

</ng-container>

<ng-template #navUnauthenticated>

    <nav class="bg-light navbar navbar-expand-xl navbar-light navbar-primary navbar-primary-home-2">
        <div class="container-fluid"><a class="navbar-brand" [routerLink]="'/'" title="Ir a Home de Profejobs"><img
                    src="images/logo.png" alt="Logotipo de Profejobs" class="logo-main-navbar" /></a>
            <button id="btn-navbar-toggler" class="navbar-toggler" type="button" data-toggle="collapse"
                data-target="#navbarToggler" aria-controls="" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse justify-content-sm-end navbar-collapse navbar-collapse-padding-sm" id="navbarToggler">
                <div class="mr-lg-auto wrap-navItem">

                    <app-navigation-bar-white class="flex-wrap nav nav-style-1 no-overflow-x">
                    </app-navigation-bar-white>

                </div>
                <div class="align-items-center d-flex flex-wrap">
                    <div class="with-separator wrap-navItem">
                        <div class="dropdown">
                            <button class="btn btn-sm dropdown-toggle" type="button" id="dropdownRegisterNavbar"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Unirme</button>
                            <div [class.dropdown-menu-right]="innerWidth1200" class="dropdown-menu"
                                aria-labelledby="dropdownRegisterNavbar">
                                <a class="dropdown-item"
                                    [routerLink]="[constantsService.BASE_PATH_EMPLOYEE_BASIC]">Profesor</a>
                                <a class="dropdown-item"
                                    [routerLink]="[constantsService.BASE_PATH_EMPLOYER]">Institución</a>
                            </div>
                        </div>
                    </div>
                    <div class="wrap-navItem">
                        <div class="dropdown">
                            <button class="btn btn-sm dropdown-toggle" type="button" id="dropdownLoginNavbar"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Ingresar</button>
                            <div [class.dropdown-menu-right]="innerWidth1200" class="dropdown-menu"
                                aria-labelledby="dropdownLoginNavbar">
                                <a class="dropdown-item"
                                    [routerLink]="[constantsService.BASE_PATH_LOGIN_EMPLOYEE]">Profesor</a>
                                <a class="dropdown-item"
                                    [routerLink]="[constantsService.BASE_PATH_LOGIN_EMPLOYER]">Institución</a>
                            </div>
                        </div>
                    </div>
                    <div class="wrap-navItem btn-block-xs">
                        <a class="btn btn-block-xs btn-success round-btn"
                            [routerLink]="[constantsService.BASE_PATH_LANDING_PREMIUM]" target="_self">Reclutadores</a>
                    </div>
                </div>
            </div>
        </div>
    </nav>

</ng-template>

<!-- <modal-bar-employee-substitution (eventCancel)="onCancelActionSubstitution()"
    #modalBarEmployeeSubstitution></modal-bar-employee-substitution> -->